'use client';

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { ReactNode } from 'react';

import { useRuntimeConfig } from '@/hooks/useRuntimeConfig';
import { createMsalConfig } from '@/lib/msalConfig';

import { AuthProvider } from './auth-provider';

interface MsalProviderWrapperProps {
    children: ReactNode;
}

export function MsalProviderWrapper({ children }: MsalProviderWrapperProps) {
    const config = useRuntimeConfig();
    const msalConfig = createMsalConfig(config.azureAd);
    const msalInstance = new PublicClientApplication(msalConfig);

    return (
        <MsalProvider instance={msalInstance}>
            <AuthProvider>{children}</AuthProvider>
        </MsalProvider>
    );
}

